<!-- eslint-disable -->
<template>
  <div class="logo">
    <router-link
      :to="logoLink"
    >
      <acv-logo
        alt="ACV user management app logo"
        title="ACV user management app"
      />
    </router-link>
  </div>
</template>

<script>
import AcvLogo from '@/assets/svg/acv-logo.svg';

export default {
  name: 'Logo',
  components: {
    AcvLogo,
  },
  data() {
    return {
      eventId: this.$store.state.hackathonID || undefined,
    };
  },
  computed: {
    logoLink() {
      return (this.eventId) ? { name: 'Event', eventId: this.eventId } : { name: 'Login' };
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 200px;
  width: 100%;
  height: auto;
}
</style>
